import { cloneDeep } from 'lodash-es';
import zhCN from './zh-cn';

const locales = {
  'zh-CN': zhCN,
  api: cloneDeep(zhCN)
};

export default locales;
